export enum EFooterStyleInput {
  Primary = "primary",
  Secondary = "secondary",
}
